import React from "react";
import { Stethoscope, Pill, BookOpen, User } from "lucide-react";

const AVATAR_CONFIG = {
    doctor: {
        bg: "linear-gradient(135deg,#0A3D7A,#1B5BA8)",
        fg: "#FFFFFF",
        Icon: Stethoscope,
        ring: "#B8860B",
    },
    jenny: {
        bg: "linear-gradient(135deg,#B8860B,#E0A800)",
        fg: "#1A1A2E",
        initials: "J",
        ring: "#0A3D7A",
    },
    tom: {
        bg: "linear-gradient(135deg,#0A5C36,#0E7A48)",
        fg: "#FFFFFF",
        initials: "T",
        ring: "#0A3D7A",
    },
    walgreens: {
        bg: "linear-gradient(135deg,#A31621,#C12431)",
        fg: "#FFFFFF",
        Icon: Pill,
        ring: "#FFE7A8",
    },
    bookclub: {
        bg: "linear-gradient(135deg,#5B2A8A,#7C3FB8)",
        fg: "#FFFFFF",
        Icon: BookOpen,
        ring: "#B8860B",
    },
    default: {
        bg: "linear-gradient(135deg,#0A3D7A,#1B5BA8)",
        fg: "#FFFFFF",
        Icon: User,
        ring: "#0A3D7A",
    },
};

function initialsFrom(name) {
    if (!name) return "";
    return name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();
}

export const Avatar = ({
    seed,
    name,
    size = 48,
    ring = true,
    testId,
    className = "",
}) => {
    const conf = AVATAR_CONFIG[seed] || AVATAR_CONFIG.default;
    const fallbackInitials = conf.initials || initialsFrom(name) || "•";
    const Icon = conf.Icon;
    const dim = `${size}px`;

    return (
        <div
            aria-hidden="true"
            data-testid={testId}
            className={`relative shrink-0 rounded-full flex items-center justify-center overflow-hidden ${
                ring ? "ring-2 ring-offset-1 ring-offset-white" : ""
            } ${className}`}
            style={{
                width: dim,
                height: dim,
                background: conf.bg,
                color: conf.fg,
                ...(ring ? { boxShadow: `0 0 0 2px ${conf.ring}` } : null),
            }}
        >
            {Icon ? (
                <Icon
                    style={{
                        width: size * 0.5,
                        height: size * 0.5,
                    }}
                    strokeWidth={2.2}
                />
            ) : (
                <span
                    className="font-display font-bold tracking-tight"
                    style={{ fontSize: size * 0.42 }}
                >
                    {fallbackInitials}
                </span>
            )}
        </div>
    );
};

export default Avatar;
